import { css } from '@emotion/core';
import { unset } from 'lodash';
import { colorsPalette, shadows } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';
import { typography, fontWeights } from '../../../../styles/typography';

const converted = {
  width: '100%',
  display: 'block',
  maxWidth: '100%',
  margin: '0px auto',
  overflow: 'hidden',
  height: '770px',

  [MediaQueries.xl]: {
    height: '800px',
    marginBottom: '64px',
  },
  [MediaQueries.lg]: {
    height: '700px',
  },

  [MediaQueries.md]: {
    height: '450px',
  },
  [MediaQueries.sm]: { height: '240px' },

  '.pagination': {
    position: 'absolute',
    width: '100%',
    bottom: '0px',
    textAlign: 'center',
    [MediaQueries.sm]: { bottom: '16px' },
    [MediaQueries.md]: { bottom: '40px' },
    [MediaQueries.lg]: { bottom: '30px' },

    div: {
      width: '8px',
      height: '8px',
      display: 'inline-block',
      borderRadius: '100%',
      background: '#000',
      margin: '0px 4px',
      opacity: '0.25',
      border: '0',
    },

    '.indicator': { background: '#008385', opacity: 'unset' },
  },

  '.slider .content': { width: '100%', height: '100%', position: 'relative' },
  '.slide': {
    pointerEvents: 'all',
    position: 'absolute',
    textAlign: 'center',
    width: '90%',
    left: '50%',
    height: '100%',
    // transition: 'transform 500ms, padding 500ms, height 500ms',
    transition: 'all 500ms',
    '*': {
      transition: 'all 500ms',
    },
  },
  '.slide img': { width: '100%' },

  '.slide.previous,.slide.next': {
    // opacity: 0.3,
    cursor: 'pointer',
    height: '670px',
    // transition: 'transform 500ms, padding 500ms, height 500ms',
    zIndex: -1,
  },

  '.slide.previous > div,.slide.next > div': {
    transform: 'scale(0.8)',
    [MediaQueries.sm]: { transform: 'scale(0.9)' },
  },

  '.slide.next img,.slide.previous img': {
    height: '700px',
    padding: '65px 0 65px',

    [MediaQueries.xl]: {
      height: '750px',
      padding: '13px 0 13px',
    },

    [MediaQueries.lg]: {
      height: '680px',
      padding: '13px 0 13px',
      objectFit: 'cover',
    },

    [MediaQueries.md]: {
      height: '410px',
      padding: '13px 0 13px',
    },
    [MediaQueries.sm]: {
      height: '203px',
      padding: '13px 0 13px',
    },
  },

  '.slide.current img': {
    height: '1350px',
    objectFit: 'cover',
    [MediaQueries.xl]: {
      height: '750px',
    },
    [MediaQueries.lg]: {
      height: '680px',
      objectFit: 'cover',
    },

    [MediaQueries.md]: {
      height: '410px',
    },
    [MediaQueries.sm]: {
      height: '203px',
      objectFit: 'cover',
    },
  },
  '.slide.current': { transform: 'translateX(-50%)' },
  '.slide.previous': {
    transform: 'translateX(-142%)',
    [MediaQueries.sm]: { transform: 'translateX(-148%)' },
  },
  '.slide.next': {
    // transition: 'all 2000ms',
    transform: 'translateX(42%)',
    [MediaQueries.sm]: { transform: 'translateX(48%)' },
  },
  '.slide-enter.previous': { transform: 'translateX(-270%)' },
  '.slide-enter-active.previous': { transform: 'translateX(-160%)' },
  '.slide-leave.previous': { transform: 'translateX(-160%)' },
  '.slide-leave-active.previous': { transform: 'translateX(-270%)' },
  '.slide-enter.next': { transform: 'translateX(170%)' },
  '.slide-enter-active.next': { transform: 'translateX(60%)' },
  '.slide-leave.next': { transform: 'translateX(60%)' },
  '.slide-leave-active.next': { transform: 'translateX(170%)' },
  '.indicators': {
    margin: '0px 0',
    position: 'relative',
    bottom: '0',
    display: 'flex',
    justifyContent: 'center',

    '.leftrightarrow': {
      position: 'relative',
      top: '335px',
      display: 'flex',
      justifyContent: 'space-between',
      width: '93%',
      zIndex: 999,
    },
  },

  '.indicators .centerimagebg': {
    width: '90%',
    height: '750px',
    position: 'absolute',
    display: 'flex',
    justifyContent: 'space-between',
    [MediaQueries.xl]: {
      height: '750px',
    },
    [MediaQueries.lg]: {
      height: '700px',
    },
    [MediaQueries.md]: {
      height: '435px',
      width: '100%',
    },
    [MediaQueries.sm]: {
      height: '225px',
      width: '100%',
    },

    zIndex: 1,
    marginTop: '0px',

    '.leftarrowbg': {
      width: '100%',

      display: 'flex',
      alignItems: 'center',
      button: {
        display: 'none',
      },
    },

    '.rightarrowbg': {
      width: '100%',
      justifyContent: 'flex-end',
      display: 'flex',
      alignItems: 'center',
      button: {
        display: 'none',
      },
    },
  },

  '.indicators .centerimagebg:hover': {
    '.left_arrow': {
      display: 'block',
      left: '-32px',
      position: 'relative',
      [MediaQueries.md]: {
        display: 'none',
      },
      [MediaQueries.sm]: {
        display: 'none',
      },
    },
    '.right_arrow': {
      display: 'block',
      right: '-32px',
      position: 'relative',
      [MediaQueries.md]: {
        display: 'none',
      },
      [MediaQueries.sm]: {
        display: 'none',
      },
    },
  },

  '.indicators button': {
    border: '0',
    margin: '0px 5px',

    cursor: 'pointer',
    width: '48px',

    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    height: '48px',
    background: '#fff',
    boxShadow: '0px 5px 20px rgba(0, 0, 0, 0.12)',
  },
  '.indicators .in-active': { opacity: 0.2 },
  '.indicators .left_arrow img': {
    WebkitTransform: 'scaleX(-1)',
    transform: 'scaleX(-1)',
  },
  '.indicator': {
    margin: '0 2px',
    width: '10px',
    height: '10px',
    border: '1px solid black',
    borderRadius: '50%',
    backgroundColor: 'white',
  },
  '.indicator.active': { backgroundColor: 'blue' },
};

export const customSliderStyle = css(converted);
